import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ApplicationState } from '@/state/root.models'

import { useChartCardPagination } from '@/views/personalization-engine/hooks'
import { ChartCardComponent } from '../chart-content'

export const GameProvidersComponent = () => {
  const { t } = useTranslation()

  const { gameProvider, isLoadingGameProvider } = useSelector(
    ({ personalizationEngine }: ApplicationState) => personalizationEngine,
  )

  const { paginatedRows, pagination, handleChangeLimit, handleChangePage } =
    useChartCardPagination({ data: gameProvider })

  return (
    <ChartCardComponent
      data={gameProvider}
      paginatedRows={paginatedRows}
      title={t('personalizationEngine.gameProvider')}
      isLoading={isLoadingGameProvider}
      pagination={pagination}
      handleChangeLimit={handleChangeLimit}
      handleChangePage={handleChangePage}
    />
  )
}
